import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AnalysisCacheProvider } from './context/AnalysisCacheContext';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './components/HomePage';
import Dashboard from './components/Dashboard';
import LapVisualizationPage from './components/LapVisualizationPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Footer from './components/Footer';
import './styles/App.css';

const AppContent: React.FC = () => {

  return (
    <div className="app-container">
      <ErrorBoundary fallback={
        <div className="route-error">
          <h2>Navigation Error</h2>
          <p>There was a problem loading this page.</p>
        </div>
      }>
        <Routes>
          <Route path="/" element={<HomePage />} />
          
          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            {/* Dashboard routes */}
            <Route path="/dashboard" element={
              <ErrorBoundary fallback={
                <div className="dashboard-error">
                  <h2>Dashboard Error</h2>
                  <p>There was a problem loading the dashboard.</p>
                  <button onClick={() => window.location.reload()}>
                    Refresh Page
                  </button>
                </div>
              }>
                <Dashboard />
              </ErrorBoundary>
            } />
            
            {/* Dashboard settings */}
            <Route path="/dashboard/settings" element={
              <ErrorBoundary fallback={
                <div className="dashboard-error">
                  <h2>Settings Error</h2>
                  <p>There was a problem loading settings.</p>
                  <button onClick={() => window.location.reload()}>
                    Refresh Page
                  </button>
                </div>
              }>
                <Dashboard />
              </ErrorBoundary>
            } />

            {/* Dashboard with specific session open */}
            <Route path="/dashboard/session/:sessionId" element={
              <ErrorBoundary fallback={
                <div className="dashboard-error">
                  <h2>Dashboard Error</h2>
                  <p>There was a problem loading the dashboard.</p>
                  <button onClick={() => window.location.reload()}>
                    Refresh Page
                  </button>
                </div>
              }>
                <Dashboard />
              </ErrorBoundary>
            } />

            {/* Full-screen lap view */}
            <Route path="/dashboard/session/:sessionId/lap/:lapNumber" element={
              <ErrorBoundary fallback={
                <div className="lap-error">
                  <h2>Lap View Error</h2>
                  <p>There was a problem loading the lap view.</p>
                  <button onClick={() => window.history.back()}>
                    Go Back
                  </button>
                </div>
              }>
                <LapVisualizationPage />
              </ErrorBoundary>
            } />
          </Route>
          
          {/* Redirect to homepage for any undefined routes */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ErrorBoundary>
      
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AnalysisCacheProvider>
        <Router>
          <AppContent />
        </Router>
      </AnalysisCacheProvider>
      <Analytics />
    </ErrorBoundary>
  );
};

export default App;
